module.exports = __webpack_public_path__ + "static/bootstrap-popover-2156cdbc34877a3ebff8838eae3d1e64.png";